/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ClaimsSchemaFieldsItem } from './ClaimsSchemaFieldsItem';

export const ClaimsSchema: core.serialization.ObjectSchema<serializers.ClaimsSchema.Raw, Truvity.ClaimsSchema> =
    core.serialization.object({
        fields: core.serialization.list(ClaimsSchemaFieldsItem),
        jsonLdBaseIri: core.serialization.property('json_ld_base_iri', core.serialization.string().optional()),
        jsonLdIri: core.serialization.property('json_ld_iri', core.serialization.string().optional()),
        jsonLdRelativeIriDelimiter: core.serialization.property(
            'json_ld_relative_iri_delimiter',
            core.serialization.string().optional(),
        ),
        jsonLdTermName: core.serialization.property('json_ld_term_name', core.serialization.string().optional()),
    });

export declare namespace ClaimsSchema {
    export interface Raw {
        fields: ClaimsSchemaFieldsItem.Raw[];
        json_ld_base_iri?: string | null;
        json_ld_iri?: string | null;
        json_ld_relative_iri_delimiter?: string | null;
        json_ld_term_name?: string | null;
    }
}
